/**
 * EmptyState — small honest empty-state block used across shell pages.
 * NEVER fabricate rows here; always say clearly what will populate it
 * and roughly when.
 */
export default function EmptyState({
    title,
    body,
    icon: Icon = null,
    footnote = null,
    className = "",
}) {
    return (
        <div
            data-testid="empty-state"
            className={`qoryn-panel rounded-2xl p-8 flex flex-col items-center text-center gap-3 ${className}`}
        >
            {Icon && (
                <div className="flex items-center justify-center h-9 w-9 rounded-lg bg-white/[0.03] text-qoryn-cyan/70">
                    <Icon className="h-4 w-4" strokeWidth={1.5} />
                </div>
            )}
            <h3 className="font-display text-[18px] font-light tracking-tight text-qoryn-text">
                {title}
            </h3>
            {body && (
                <p className="font-sans text-[13px] text-qoryn-textDim max-w-md leading-relaxed">
                    {body}
                </p>
            )}
            {footnote && (
                <p className="font-mono-ui text-[9px] tracking-widest uppercase text-qoryn-textMuted mt-1">
                    {footnote}
                </p>
            )}
        </div>
    );
}
